import React, { useState } from 'react';

const OrdersTabPills = ({ tabs, activeTabKey, onTabSelect }) => {
  const [hoverTab, setHoverTab] = useState(null);

  const getActiveTabBgColor = tab => {
    switch (tab.key) {
      case 'lienSearch':
        return '#F59E0B';
      case 'estoppel':
        return '#8B5CF6';
      case 'survey':
        return '#10B981';
    }
  };
  return (
    <div className="d-flex align-items-center justify-content-start m-0">
      <div className="d-flex align-items-center justify-content-center">
        {tabs.map(tab => {
          const isActive = tab.key === activeTabKey;
          const isHover = hoverTab === tab.key;
          const hasOrder = tab.hasOrder !== false; // Default to true if not specified

          return (
            <div
              key={tab.key}
              className="d-flex align-items-center justify-content-center mr-1"
              style={{
                width: 'fit-content',
                backgroundColor: isActive && hasOrder ? ` ${getActiveTabBgColor(tab)}` : 'transparent',
                borderRadius: '14px',
                padding: '4px 3px',
                transition: 'all 0.1s ease'
              }}
            >
              <button
                type="button"
                className={`${tab.className || ''} ${isActive && hasOrder ? 'text-white' : ''}`}
                onClick={() => onTabSelect(tab.key)}
                onMouseEnter={() => setHoverTab(tab.key)}
                onMouseLeave={() => setHoverTab(null)}
                style={{
                  padding: '7px 16px',
                  backgroundColor: hasOrder
                    ? isHover && !isActive
                      ? `${getActiveTabBgColor(tab)}EA`
                      : getActiveTabBgColor(tab)
                    : 'transparent',

                  border: hasOrder
                    ? isActive
                      ? '2px solid white'
                      : '2px solid transparent'
                    : isHover
                    ? `2px dashed ${getActiveTabBgColor(tab)}`
                    : '2px dashed grey',
                  borderRadius: '10px',
                  opacity: hasOrder ? 1 : 0.6,
                  minHeight: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  ...tab.style
                }}
              >
                <span
                  className={
                    hasOrder
                      ? isActive
                        ? 'font-weight-bold'
                        : 'font-weight-medium'
                      : isHover
                      ? 'font-weight-medium'
                      : 'text-muted font-weight-medium'
                  }
                  style={{
                    color: hasOrder ? 'white' : isHover && getActiveTabBgColor(tab) ? getActiveTabBgColor(tab) : 'grey'
                  }}
                >
                  {tab['name']}
                </span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrdersTabPills;
